import React from "react";
import "./navbar.css"

export const Navbar = (props) => {
  return (
    <section class="main-containers">
      <div class="page-headers">
        <h1 style={{color:"white"}}>{props.pagename}</h1>
      </div>
    </section>
  );
};
